import qs from "qs";
import { api } from "shared/api";
import { API_ROUTES, defaultOptions } from "shared/api/consts";
import { ActivateGiftDTO, BuyGiftDTO } from "./models";

export const BuyGiftApi = async (dto: BuyGiftDTO) => {
  const { data } = await api.post(
    API_ROUTES.BONUS_REQUEST,
    qs.stringify({ ...defaultOptions(), ...dto })
  );

  return data;
};

export const ActivateGiftApi = async (dto: ActivateGiftDTO) => {
  const { data } = await api.post(
    API_ROUTES.BONUS_ACTIVATE,
    qs.stringify({ ...defaultOptions(), ...dto })
  );

  return data;
};

export const GetTransactionBonusesApi = async (dto: any) => {
  const { data } = await api.post(
    API_ROUTES.TRANSACTION_BONUSES,
    qs.stringify({ ...defaultOptions(), activated: 0, ...dto })
  );

  return data;
};
